<template>
    <div class="background-circle-3">
        <svg width="1440" height="547" viewBox="0 0 1440 547" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect opacity="0.21" x="-180" width="1799" height="1800" rx="899.5" fill="#CBD5FB"/>
        </svg>
    </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
.background-circle-3 {
    display: flex;
    justify-content: center;

    svg {
        width: 100%;
    }
}
</style>
